module.exports = __webpack_public_path__ + "img/gift4-01-c08-t1.de2fb4c3.png";